var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSkipNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#skip_next_svg__clip0_1442_3591)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6 18 8.5-6L6 6v12Zm2-8.14L11.03 12 8 14.14V9.86ZM16 6h2v12h-2V6Z"
}))));
export default SvgSkipNext;